import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
  },
  root: {
    border: 'none',

    '& .ql-toolbar': {
      borderBottom: `1px solid ${theme.palette.custom.grey}`,
      borderRight: `1px solid ${theme.palette.custom.grey}`,
      borderLeft: `1px solid ${theme.palette.custom.grey}`,
      borderTop: 'none',

      '& .ql-formats': {
        '& .ql-picker-label': {
          color: theme.palette.custom.darkBlue2,
        },

        '& .ql-stroke': {
          stroke: theme.palette.custom.darkBlue2,
        },
        '& .ql-fill': {
          fill: theme.palette.custom.darkBlue2,
        },
      },
    },

    '& .ql-container': {
      border: `1px solid ${theme.palette.custom.grey}`,

      [theme.breakpoints.down('tablet')]: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
      },

      [theme.breakpoints.up('tablet')]: {
        borderBottomLeftRadius: 15,
        borderBottomRightRadius: 15,
      },

      '& .ql-editor': {
        minHeight: 160,
      },
    },

    '& .ql-tooltip': {
      zIndex: 2000,
    },
  },
  label: {
    '&&': {
      border: `1px solid ${theme.palette.custom.grey}`,
      borderBottom: 'none',

      [theme.breakpoints.down('tablet')]: {
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      },

      [theme.breakpoints.up('tablet')]: {
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
      },

      paddingTop: SPACES.xxxs,
      paddingLeft: SPACES.m,
      paddingBottom: SPACES.xxxs,
      lineHeight: 1.4,
      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('laptop')]: {
        fontSize: '0.525rem',
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('laptop')]: {
        fontSize: '0.675rem',
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  errText: {
    '&&': {
      marginLeft: SPACES.xxl,
      display: 'inline-flex',

      color: theme.palette.error.main,
      lineHeight: 1.66,
      fontSize: FONTS.SIZES.s,
    },
  },
}))
